import React from 'react'
// import { Link, useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
function Construction() {
    // const [active, setActive] = useState("Safe Area");
    // const navigate = useNavigate();

    const clients = [
        {
            img: "/assets/services/weatherproof-hazardous-enclosures.svg",
            title: "Outdoor, Fire Rated &amp; Temperature Controlled Enclosures",
            text: "Customised temperature-controlled enclosures with accessories in metal and polymers are designed to suit the stringent local weather conditions.",
            link: "/services/weatherproof-hazardous-enclosures"
        },
        {
            img: "/assets/services/instrumentation-control-cables.svg",
            title: "IP68 Gel Filled Connectors",
            text: "Suitable for damp and moisture laden areas within the internal and external construction zone. Excellent for façade lighting applications.",
            link: "/services/instrumentation-control-cables"
        },
        {
            img: "/assets/services/cable-glands-lugs-cleats.svg",
            title: "GRMS (Guest Room Management System) Solution & Components",   
            text: "Supply of panels, DIN Rails, terminals, cable accessories & tools connecting IoT to the power output",
            link: "/services/cable-glands-lugs-cleats"
        },
        {
            img: "/assets/services/cable-ties-fixings.svg",
            title: "Combination Units",
            text: "High quality pre-coated galvanised steel boxes with adjustable mounting lug(s) to impart professional work look to electrical accessories upon installation.",
            link: "/services/cable-ties-fixings"
        },
        {
            img: "/assets/services/instrumentation-tubing-fittings.svg",
            title: "In-Ground Power Supply Unit",
            text: "Suitable for outdoor and indoor applications in metals and polymers to secure and power the cables",
            link: "/services/instrumentation-tubing-fittings"
        }, {
            img: "/assets/services/instrumentation-tubing-fittings.svg",
            title: "In-Ground Power Supply Unit",
            text: "Suitable for outdoor and indoor applications in metals and polymers to secure and power the cables",
            link: "/services/instrumentation-tubing-fittings"
        },
         {
            img: "/assets/services/instrumentation-tubing-fittings.svg",
            title: "In-Ground Power Supply Unit",
            text: "Suitable for outdoor and indoor applications in metals and polymers to secure and power the cables",
            link: "/services/instrumentation-tubing-fittings"
        },
         {
            img: "/assets/services/instrumentation-tubing-fittings.svg",
            title: "Cable Ladder &amp; Trays",
            text: "Suitable for outdoor and indoor applications in metals and polymers to secure and power the cables",
            link: "/services/instrumentation-tubing-fittings"
        },
          {
            img: "/assets/services/instrumentation-tubing-fittings.svg",
            title: "Rigid &amp; Flexible Conduits",
            text: "Suitable for outdoor and indoor applications in metals and polymers to secure and power the cables",
            link: "/services/instrumentation-tubing-fittings"
        },
          {
            img: "/assets/services/instrumentation-tubing-fittings.svg",
            title: "GI Back Box/Switch &amp; Socket boxes",
            text: "Suitable for outdoor and indoor applications in metals and polymers to secure and power the cables",
            link: "/services/instrumentation-tubing-fittings"
        },
          {
            img: "/assets/services/instrumentation-tubing-fittings.svg",
            title: "Cable Glands, Cleats &amp; Lugs",
            text: "Suitable for outdoor and indoor applications in metals and polymers to secure and power the cables",
            link: "/services/instrumentation-tubing-fittings"
        },
        {
            img: "/assets/services/instrumentation-tubing-fittings.svg",
            title: "Identification &amp; Labelling Systems",
            text: "Suitable for outdoor and indoor applications in metals and polymers to secure and power the cables",
            link: "/services/instrumentation-tubing-fittings"
        },

    ];
    return (
        <>
        <Helmet>
    <title>
        Construction Electrical & Cable Solutions UAE | Al Ibtekar
    </title>

    <meta
        name="description"
        content="Al Ibtekar provides construction electrical and cable management solutions in the UAE, including weatherproof enclosures, IP68 gel connectors, GRMS solutions, cable trays, conduits, cable glands, cleats, lugs and identification systems."
    />

    <meta
        name="keywords"
        content="construction electrical solutions UAE, construction cable management UAE, electrical enclosures UAE, IP68 gel connectors UAE, GRMS solutions UAE, cable trays UAE, cable conduits UAE, cable glands UAE, cable cleats UAE, cable lugs UAE, construction electrical supplier UAE"
    />

    <link
        rel="canonical"
        href="https://saig.me/construction"
    />

    <meta
        property="og:title"
        content="Construction Electrical & Cable Solutions UAE | Al Ibtekar"
    />

    <meta
        property="og:description"
        content="Reliable electrical, cable management and building infrastructure solutions for construction projects across the UAE."
    />

    <meta
        property="og:url"
        content="https://saig.me/construction"
    />

    <meta
        property="og:type"
        content="website"
    />
</Helmet>
            <div className='newbanner-about newbanner-about3'>
                <div className="max-w-[1440px] w-full mx-auto lg:px-[50px] px-[20px]">
                    <h6 className="font-[500] font-kanit lg:text-[60px] text-[30px] lg:leading-[90px] leading-[40px] text-[#FFFFFF] lg:pb-[14px] pb-[4px]">Construction</h6>
                    <p className="lg:max-w-[582px] max-w-[250px] w-full font-[300] font-inter lg:text-[20px] text-[12px] lg:leading-[30px] leading-[16px] text-[#FFFFFF]">Building strong foundations for tomorrow’s infrastructure.
                    </p>
                </div>
            </div>

         <div className='newbg'>

               <div className='max-w-[1440px] w-full mx-auto lg:px-[50px] px-[20px] overflow-hidden allheader mb-[20px]'>
  <h2>Construction</h2>
  <div className='line'></div>
                         <h3 className='text-left'>Over the past 20 years, the UAE market has grown by leaps and bounds in terms of the quantity and quality of construction. Over the years the complexity of the projects has increased considering - environment, sustainability, building automation, high-security systems, IoT, wireless solutions etc. Considering the above facts, we offer a range of carefully selected sturdy and build to last components & solutions, as listed below:</h3>

               </div>
               </div>
            <section className='lg:pb-[10px] pb-[60px]'>
                <div className="grid lg:grid-cols-2 grid-cols-1 pb-[36px] lg:gap-[90px] gap-[30px] max-w-[1440px] w-full mx-auto lg:px-[50px] px-[20px]">
                    <div>
                         <div className="lg:sticky lg:top-[100px] self-start">
    <div className="h-[auto] mb-[15px] w-full justify-center flex items-center rounded-[12px] p-[22px]">
                            <img src="/assets/grms.png" className='rounded-[12px] w-full' alt="	Trusted cable management and termination solutions provider in the UAE" />
                        </div>
                        </div>

                    </div>
<div className='pt-[11px]'>
  <ul className="mt-4 grid grid-cols-1 md:grid-cols-1 gap-1">
    {[
      "Outdoor, Fire Rated & Temperature Controlled Enclosures",
      "IP68 Gel Filled Connectors",
      "GRMS (Guest Room Management System) Solution & Components",
      "Combination Units",
      "In-Ground Power Supply Unit",
      "Cable Ladder & Trays",
      "Rigid & Flexible Conduits",
      "GI Back Box/Switch & Socket boxes",
      "Cable Glands, Cleats & Lugs",
      "Identification & Labelling Systems",
    ].map((item, i) => {
      const isGRMS = item.includes("GRMS");

      return (
        <li
          key={i}
          className="flex items-start gap-3 rounded-lg bg-white px-4 transition"
        >
          <span className="mt-1 text-[#e09e0f] text-sm font-semibold">●</span>

          <span
            className="text-[18px] leading-relaxed aplus"
            style={
              isGRMS
                ? { fontWeight: "600", color: "#000" }
                : { color: "#374151" }
            }
          >
            {item}
          </span>
        </li>
      );
    })}
  </ul>

  <Link to='/industries'>
    <button className='backbtn'>
      Back To Industries
    </button>
  </Link>
</div>
                </div>
                {/* <div className='detail-div-p detail-div-p-2 max-w-[1440px] w-full mx-auto lg:px-[50px] px-[20px]'>
                    <div className='detail-div-p-div'>
                        <h3>IP66/67/68 Weatherproof Enclosures & Connectors</h3>
                        <p>Suitable for damp and moisture laden areas within the internal and external construction zone. Excellent for façade lighting applications. </p>
                    </div>
                    <div className='detail-div-p-div'>
                        <h3>GRMS (Guest Room Management System) </h3>
                        <p>Supply of panels, DIN Rails, terminals, cable accessories & tools connecting IoT to the power output   </p>
                    </div>
                    <div className='detail-div-p-div'>
                        <h3>GI Back Box/Switch & Socket boxes</h3>
                        <p>High quality pre-coated galvanised steel boxes with adjustable mounting lug(s) to impart professional work look to electrical accessories upon installation. </p>
                    </div>
                    <div className='detail-div-p-div'>
                        <h3>Cable Glands, Cleats & Lugs</h3>
                        <p>  Suitable for outdoor and indoor applications in metals and polymers to secure and power the cables  </p>
                    </div>
                </div> */}
            </section>

            {/* <section className="bg-[#fff] dark:bg-[#FBB210] py-[60px] md:py-[50px]">
                <div className="max-w-[1440px] flex flex-col lg:flex-row justify-between items-start mx-auto w-full gap-[40px] lg:px-[50px] px-[20px]">
                    <div className="lg:max-w-[480px] max-w-[100%] w-full text-[#000] dark:text-[#000000] lg:sticky lg:top-[150px] self-start">
                        <h6 data-aos="fade-right" className="text-[28px] lg:text-[48px] font-outfit font-[400] mb-[24px] leading-[40px] lg:leading-[56px]">
                           Strength meets innovation.
                        </h6>

                        <div className="group inline-flex items-center cursor-pointer">
                            <i className="bi bi-arrow-right text-[#fff] text-[40px] transition-transform duration-300 ease-in-out group-hover:translate-x-2"></i>
                        </div>

                    </div>
                    <div className="lg:max-w-[600px] max-w-[100%] w-full">
                        <div className="grid gap-[20px]">
                            {clients.map((item, index) => (
                                <div key={index}>
                                    <div
                                        className="nsr border group relative rounded-[8px]  backdrop-blur-[10px] p-[15px] md:p-[20px] pr-[60px] md:pr-[74px] transition-transform duration-300 transform hover:scale-[1.03] hover:shadow-lg"
                                        style={{ boxShadow: "0px 4px 10px 0px #0000000D" }}
                                    >
                                        <div className="flex flex-col sm:flex-row gap-[15px] md:gap-[30px] items-start">

                                            <div className='text-[#000] dark:text-[#000000]'>
                                                <h6 className="text-[20px] font-outfit md:text-[24px] lg:text-[26px] font-[500] dark:text-[#000] dark:group-hover:text-white">                                                    {item.title}
                                                </h6>
                                               
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </section> */}

        </>
    )
}

export default Construction